import { AgencyUnpaidDetailsResponse, getUnpaidDetailsEndpoint } from '@cp-mx/common';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { getSimpleDataFetchSlice } from '@cp-shared-19/frontend-integration';
import { CpDataApi } from '../../cp-xhr';

const { reducer, fetchData } = getSimpleDataFetchSlice<AgencyUnpaidDetailsResponse, DefaultBusinessMarketApiErrorCode>({
    dataName: 'unpaidDetails',
    fetchCallback() {
        return CpDataApi.get(getUnpaidDetailsEndpoint()).then(response => response.data);
    },
});

export default reducer;
export const fetchUnpaidBalance = fetchData;
